import React from 'react'
import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { Button } from 'components'
import { STATICS } from 'statics'
import { useFirebaseEvent } from 'hooks'
import './style.scss'

export function DocumentLine({
  name,
  urlFile,
  description,
  icon,
  btnLabel = 'Baixar Documento',
  drawerKey,
  event,
}) {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  function handleClick() {
    if (event) sendEvent(event)

    if (drawerKey) dispatch(setDrawer(drawerKey))
    else window.open(urlFile)
  }

  function renderButton() {
    return (
      <Button
        className='button'
        icon={icon || <STATICS.ALTERNATIVE_DOWNLOAD />}
        color='primary'
        onClick={handleClick}
      >
        {btnLabel}
      </Button>
    )
  }

  return (
    <div className='document-line-component'>
      <div className='wrapper'>
        <p className='field'>{name}</p>
      </div>
      <div className='wrapper'>
        <p className='field'>{description}</p>
      </div>
      <div className={`${drawerKey ? 'drawer' : ''} actions`}>{renderButton()}</div>
    </div>
  )
}
